<template>
  <section class="home-bed">
    <!-- <div class='tab'
         v-bind:style="{height:immersed +'px'} "></div> -->
    <div class="img-bed">
      <back-bar title="开卡激活" :showMore="barShowMore" :canGoHome="true"></back-bar>
    </div>
    <bar-list :funcClicked="barListClicked" :show="showMoreList" :list="['操作说明','用户协议']"></bar-list>
    <div class="card-box">
      <img src="../assets/img/noAccess/img_card.png">
      <span>武汉通SIM交通卡</span>
    </div>
    <div class="operation">
      <div class="li"
           @click="goUseWord"> <img src="../assets/img/noAccess/icon_operation.png">
        <span>操作说明</span>
      </div>
      <div class="li"
           @click="goPhoneType">
        <img src="../assets/img/noAccess/icon_phoneType.png">
        <span>部分适配机型</span>
      </div>

    </div>
    <div class="word">
      <span>说明：</span>
      <span>1.手机具有NFC功能且可选择SIM卡通道</span>
      <span>2.需要使用移动的超级SIM卡（NFC-SIM卡）和放SIM1卡槽</span>
      <span>3.刷卡时，系统的NFC默认付款设置为SIM卡</span>
      <div class="questions" @click="goQuestiones">常见问题说明</div>
    </div>
    <div class="user">
      <div class="icon"
           @click="readMe()"
           v-if="!ifRead"></div>
      <div class="icon read"
           v-else
           @click="readMe()">
        <img src="../assets/img/noAccess/duihao.png"
             alt="">
      </div>
      我已阅读并同意
      <span @click="goProtocol" style="color:#4A8EF7">《武汉通SIM交通卡用户协议》</span>
    </div>
    <div class="btn"
         @click="openCardBtnClicked"
         v-if="support == true">
      卡片激活
    </div>
    <div class="noBtn"
         v-else>
      卡片激活
    </div>
    <alert-card :isShow="isShow_add"
               title='卡片激活'
               content="是否确认激活武汉通SIM交通卡？"
               :confirmHandle="alertConfirm"
               :cancelHandle="alertCancel"
               @isShow='isShow'>
      
    </alert-card>
  </section>
</template>

<script>
import backBar from '@/components/backBar'
import alertCard from '@/components/alertCard'
import AlertCard from '../components/alertCard.vue'
import barList from '../components/barList.vue'
export default {
  name: 'home',
  data () {
    return {
      loading: true,
      scanInfo: "",
      cardInfo: {
      },
      immersed: 0,
      support: false,
      ifRead: false,
      isShow_add: false,
      showMoreList: false,//右上角菜单是否显示
    }
  },
  components: {
    backBar,
    alertCard,
    AlertCard,
    barList
},
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {
    const that = this;
    window.clearLocalStorage = that.clearLocalStorage;
    // window.AndroidToJs = that.AndroidToJs;
    window.queryCardData = that.queryCardData; // 挂载到window中
    window.cardNotSupport = that.cardNotSupport;

    window.checkKFStatus = that.checkKFStatus;//点开卡时检测开卡状态的回调

    //获取当前手机状态栏高度
    // let immersed = 0;


  },
  methods: {
    barListClicked (index) {
      console.log('index===',index)
      this.showMoreList = false
      if (index == 0) {
        this.$router.push({
          name: 'useWord'
      })
      }else if (index == 1) {
        this.$router.push({
          name: 'protocol'
      })
      }
    },
    barShowMore () {
      this.showMoreList = !this.showMoreList
    },
    readMe () {
      this.ifRead = !this.ifRead
    },
    clearLocalStorage (scanInfo) {
      this.scanInfo = scanInfo
      console.log("clearLocalStorage----------------")
      // return 'hello'
    },
    cardNotSupport (cardInfo) {
      // this.support = cardInfo;
      if (cardInfo.code == '0000') {
        this.support = cardInfo.data.support;
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: cardInfo.message
        })
      }
    },

    // AndroidToJs (scanInfo) {
    //   console.log(scanInfo)
    // },

    checkKFStatus (data) {
      // checkKFStatus:{"code":"0000","data":{"checkKFStatus":true},"message":"成功"}
      if (data.code == '0000') {
        if(data.data.checkKFStatus) {
          this.goWritingOpen();
        }else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: data.data.message
          })
        }
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: data.message
        })
      }
      // this.support = cardInfo;
    },

    openCardBtnClicked() {
      if (!this.ifRead) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请先阅读并同意《武汉通SIM交通卡用户协议》'
        })
        return
      }
      window.android.clickOpenCard(true)
    },
    goUseWord() {
      this.$router.push({
          name: 'useWord'
      })
    },
    goPhoneType() {
      this.$router.push({
          name: 'phoneType'
      })
    },
    goQuestiones() {
      this.$router.push({
          name: 'questiones'
      })
    },
    goProtocol() {
      this.$router.push({
          name: 'protocol'
      })
    },
    goWritingOpen () {

      
      this.isShow_add = true

      // window.android.queryCardData("JStoAndroid")
      // if (this.loading) {
      //   this.$router.push({
      //     name: router
      //   })
      // }
    },
    isShow() {
      console.log('isShow')
      this.isShow_add = false
    },
    alertCancel() {
      console.log('cancel')
      this.isShow_add = false
    },
    alertConfirm() {
      console.log('confirm')
      this.$router.push({
          name: 'writingOpen'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #5595fa;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  .tab {
    background-color: #5a98fc;
  }
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  height: 320px;
  // top: 20px;
  background-image: url(../assets/img/noAccess/img_top.png);
  background-repeat: no-repeat;
  background-size: cover;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    // background-color: #666;
  }
  img {
    width: 100%;
  }
}
.card-box {
  width: 92%;
  position: absolute;
  top: 110px;
  margin-left: 4%;
  img {
    width: 100%;
  }
  span {
    position: absolute;
    left: 42px;
    top: 40%;
    font-size: 40px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9019607843137255);
  }
}
.operation {
  // width: 92%;
  // position: absolute;
  // top: 460px;
  // margin-left: 4%;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  // img {
  //   width: 64px;
  //   height: 64px;
  // }
  // span {
  //   font-size: 28px;
  //   font-weight: 400;
  //   color: #333333;
  //   margin-top: 16px;
  // }
  width: 92%;
  position: absolute;
  top: 460px;
  margin-left: 4%;
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  .li {
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: center;
    align-items: center;
    img {
      width: 64px;
      height: 64px;
    }
    span {
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      margin-top: 16px;
    }
  }
}
.word {
  width: 92%;
  position: absolute;
  top: 620px;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  span {
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
  }
  .questions {
    margin-top: 10px;
    font-size: 22px;
    color: #4A8EF7;
  }
}
.user {
  width: 92%;
  position: absolute;
  bottom: 200px;
  margin-left: 4%;
  height: 33px;
  margin-top: 196px;
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  display: flex;
  align-items: center;
  .icon {
    width: 23px;
    height: 23px;
    border: 1px solid #999999;
    border-radius: 10px;
    margin-right: 16px;
  }
  .read {
    width: 23px;
    height: 23px;
    border: 1px solid #4a8ef7;
    background: #4a8ef7;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 10px;
    }
  }
}
.btn {
  position: absolute;
  bottom: 80px;
  width: 92%;
  height: 98px;
  line-height: 98px;
  margin-left: 4%;
  background: #4a8ef7;
  box-shadow: 0px 6px 20px 1px rgba(63, 138, 247, 0.2);
  border-radius: 49px 49px 49px 49px;
  text-align: center;
  font-size: 32px;
  font-weight: 400;
  color: #ffffff;
}
.noBtn {
  position: absolute;
  bottom: 80px;
  width: 92%;
  height: 98px;
  line-height: 98px;
  margin-left: 4%;
  background: #dcdcdc;
  box-shadow: 0px 6px 20px 1px rgba(0, 0, 0, 0.2);
  border-radius: 49px 49px 49px 49px;
  text-align: center;
  font-size: 32px;
  font-weight: 400;
  color: #ffffff;
}
</style>
